<template>
  <CCol class="tablesBalance" sm="12" v-if="show">
    <HeaderBalanceChannel :stateSwith="balance.state" :channel="balance.channel" :toggle-table="toggleTable" />
    <CCard class="dataTable mt-4">
      <CRow class="align-items-start">
        <CCol xs="12" lg="6" v-if="canUseBalance">
          <TableBalanceRecurring :channel="balance.channel" :recurrentAddOns="balance.recurrentAddOns" />
        </CCol>
        <CCol xs="12" lg="6">
          <TableBalanceCurrent :channel="balance.channel" :currentBalances="balance.currentBalances" />
        </CCol>
      </CRow>
    </CCard>
  </CCol>
</template>

<script>
import HeaderBalanceChannel from './HeaderBalanceChannel.vue'

export default {
  name: 'TablesBalance',
  components: {
    HeaderBalanceChannel,
    TableBalanceRecurring: () => import('./TableBalanceRecurring.vue'),
    TableBalanceCurrent: () => import('./TableBalanceCurrent.vue'),
  },
  props: {
    balance: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      show: true,
    }
  },

  computed: {
    isSendit() {
      return this.$store.getters['auth/isSendit']
    },
    planType() {
      return this.$store.getters['auth/planType']
    },
    canUseBalance() {
      if (this.isSendit && this.planType == 'STANDARD') return false
      return true
    },
  },
  methods: {
    toggleTable(state) {
      this.dispatch('toggleTable', { state })
    },
  },

  watch: {
    balance: {
      handler() {
        this.show = false

        this.$nextTick(() => {
          this.show = true
        })
      },
    },
  },
}
</script>
<style lang="scss" scope>
.isBloacked {
  opacity: 0.4;
  pointer-events: none;
}
hr {
  margin: 0.5rem 0;
}
.tableBalance {
  &__body {
    thead {
      tr {
        border-bottom: 2px solid var(--gray-300);
        pointer-events: none;
      }
      th {
        border: none;
      }
    }

    tbody {
      td,
      span {
        line-height: 30px;
      }
    }

    tbody tr {
      padding-top: 19px;

      background: transparent;
      border-bottom: 2px solid var(--gray-200);
      &:hover,
      &:hover td {
        background: transparent !important;
      }
    }
  }
  &__selectFrequency {
    background: transparent;
    height: 32px;
    cursor: pointer;

    &.vs--disabled {
      background: var(--gray-500);
    }

    .vs__dropdown-toggle,
    .vs__selected,
    .vs__actions,
    .vs__selected-options {
      height: 32px;
    }
    .vs__actions {
      cursor: pointer;
    }

    .vs__search {
      padding: 0;
      width: 0;
      margin: 0;
    }
  }

  &__btn {
    width: 30px;
    height: 30px;
    line-height: 15px;
    padding: 5px;
    transition: box-shadow 300ms;
    &--active,
    &:hover:enabled {
      background: white;
      box-shadow: 0px 5px 9px 0 rgba(34, 37, 43, 0.13) !important;
    }
  }
}
</style>
